import { render, staticRenderFns } from "./AttendeeEmailInvitePreview.vue?vue&type=template&id=c5085e92&scoped=true&"
import script from "./AttendeeEmailInvitePreview.vue?vue&type=script&lang=ts&"
export * from "./AttendeeEmailInvitePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5085e92",
  null
  
)

export default component.exports